export default "__VITE_ASSET__DBOl$8Q2__"